import { debugLog } from 'shared/logger/debugLog';
import { userWithPermissionsInDtoToUserWithPersonalData } from 'shared/domain/user/mapping/toView';
import {
  isFileReadError,
  isFileReadSuccess,
  processNewFile,
  getDirectoryPath,
  saveLocally,
  showErrors,
  toSavedLocalIds,
  sortFilesByFileName,
} from 'services/documentationUpload/model';
import type { UploadConfig } from 'services/documentationUpload';
import { enrichPdfUploadPageCountsBatch } from 'services/fileService/pdfConvertStatusService';
import {
  AssignFilesToDirectoriesInput,
} from './types';

export async function assignFilesToDirectoriesModel({
  files,
  directoriesMap,
  config,
}: AssignFilesToDirectoriesInput): Promise<void> {
  const sortedFiles = [...files].sort(sortFilesByFileName);
  const processedFiles = await Promise.all(
    sortedFiles.map(processNewFile)
  );

  const successfulFiles = await enrichPdfUploadPageCountsBatch(
    processedFiles.filter(isFileReadSuccess)
  );
  const failedFiles = processedFiles.filter(isFileReadError);

  const author = userWithPermissionsInDtoToUserWithPersonalData(
    config.currentUser,
    config.organizationId,
    config.projectId
  );

  const savedLocalIds = await Promise.all(
    successfulFiles.map(async (file) => {
      const directoryPath = getDirectoryPath(file);
      const directoryId = directoriesMap[directoryPath];

      if (directoryId) {
        return saveLocally(file, author, directoryId);
      }
      debugLog(
        '[FolderUpload] SKIPPED - no mapping for path:',
        directoryPath
      );
      return undefined;
    })
  );
  // A skipped file is not a save failure; only failed saves (null) show the error toast.
  toSavedLocalIds(savedLocalIds.filter((localId): localId is number | null => localId !== undefined));

  showErrors(failedFiles);
}
